/**********************
 DESKTOP functions
 **********************/

// sort dropdown
// this adds a param to the url when the sort dropdown is changed (ie the sort by low to high ect)
document.querySelector(".collectionControlsSortFormSelect").addEventListener("change", function () {
    const selectedValue = this.value;
    let params = createUrlParams();
    window.location.href = `${params}?sort_by=${selectedValue}`;
});


// Get filter options
let filterOptions = document.querySelectorAll(".collectionControlsFiltersContent");

// separate array from filter choices that keeps track of pricing choices only (radio buttons)
// this is done because the price params use storefront filtering with the format ?filter.v.price.lte=1000&filter.v.price.gte=500
// will always have a length of 1 because it is a radio option
let filterChoicesPrices = [];

// open filter dropdown desktop listener
filterOptions.forEach(function (element) {
    element.addEventListener("click", function () {
        openFilter(element);
    });
});

// open filter dropdown desktop
function openFilter(element) {
    // close all other filters
    filterOptions.forEach(function (filter) {
        filter.classList.remove("active");
    });
    // show clicked filter
    element.classList.add("active");
}


// close filter listener - needs to know where click event is, pass in event
document.addEventListener('click', function (event) {
    filterOptions.forEach(function (element) {
        closeFilter(element, event);
    });
});


// creates the correct url parameters for the filter
function createUrlParams() {
    // search url section
    const baseUrl = `/collections/${collection.handle}/`;

    // create url section for filter choices - doesn't include the price filtering
    let sortByStr = filterChoices.join("+").replace(/\s+/g, '-');
    let priceFilter = "";

    // create url section for price choices if there is a price filter
    if (filterChoicesPrices.length !== 0) {

        // if price filter is less than
        if (filterChoicesPrices[0].includes("<")) {
            let priceFilterNum = filterChoicesPrices[0].replace(/\D/g, '');
            priceFilter = `?filter.v.price.lte=${priceFilterNum}`;
        }

        // if price filter is greater than
        else if (filterChoicesPrices[0].includes(">") || filterChoicesPrices[0].includes("+")) {
            let priceFilterNum = filterChoicesPrices[0].replace(/\D/g, '');
            priceFilter = `?filter.v.price.gte=${priceFilterNum}`;
        }

        // if price filter is between two numbers
        else if (filterChoicesPrices[0].includes("-")) {
            let priceFilterNums = filterChoicesPrices[0].split("-");
            // first num is always the greater than
            let priceFilterNumFirst = priceFilterNums[0].replace(/\D/g, '');
            // second num is always the less than
            let priceFilterNumSecond = priceFilterNums[1].replace(/\D/g, '');

            priceFilter = `?filter.v.price.gte=${priceFilterNumFirst}&filter.v.price.lte=${priceFilterNumSecond}`;
        }
    }

    // create the new url!
    sortByStr = baseUrl + sortByStr + priceFilter;
    return sortByStr;
}

// close filter
function closeFilter(element, event) {
    // if filter open and click is outside it
    if (element.classList.contains("active")) {
        let clickedElement = event.target;
        // Click is outside filter
        if (!element.contains(clickedElement)) {
            // close filter
            element.classList.remove("active");

            // create url filter params and change url to that location
            window.location = createUrlParams();
        }
    }
}


/**********************
 FILTER functions
 **********************/

// get current url params to display on page load - used for storefront filtering
let params = {};
let url = window.location.href;
let urlParams = new URLSearchParams(url.split('?')[1]);
for (const [key, value] of urlParams) {
    params[key] = value;
}
// check if the params contain a price filter
// loop over params if the parms has more than two options
// if it has more than two options it's filtering a price between two numbers
if (Object.keys(params).length > 1) {
    //loop over params
    let priceString = [];
    for (const [key, value] of Object.entries(params)) {
        // put back into form $gte - $lte

        if (key === "filter.v.price.gte") {
            priceString.push(`>$${value}`);
        } else if (key === "filter.v.price.lte") {
            priceString.push(`<$${value}`);
        }
    }
    // join the two price strings together
    let priceStringJoined = priceString.join("-");
    // remove < > symbols
    priceStringJoined = priceStringJoined.replace(/[<>]/g, '');

    // add to price filter array
    if (priceStringJoined !== "") {
        filterChoicesPrices.push(priceStringJoined);
    }

}
// if there is only one price filter, add it to the price filter array
else if (Object.keys(params).length === 1 && Object.keys(params)[0].includes("filter.v.price")) {
    // if price filter is less than
    if (Object.keys(params)[0].includes("lte")) {
        filterChoicesPrices.push(`<$${Object.values(params)[0]}`);
    }
    // if price filter is greater than
    else if (Object.keys(params)[0].includes("gte")) {
        filterChoicesPrices.push(`>$${Object.values(params)[0]}`);
    }
    // price filter is a + type
    else {
        filterChoicesPrices.push(`$${Object.values(params)[0]}+`);
    }
}


// filter choice listener
document.querySelectorAll(".filterItemInput").forEach(function (element) {
    element.addEventListener("change", function () {

        // push checkbox choices to filterChoices array
        if (element.type === 'checkbox') {
            pushFilterChoice(filterChoices, element.value);
        }
        // push radio choice to filterChoicesPrice array
        else {
            filterChoicesPrices = [element.value];
            updateChoices();
        }
    });
});


// update the filter choices array - don't include repeat choices
function pushFilterChoice(target_array, choice) {
    // if the choice is already in the array, remove it
    if (target_array.includes(choice)) {
        target_array.splice(target_array.indexOf(choice), 1);
    } else {
        target_array.push(choice);
    }
    updateChoices();
}

// Display the current filter choices to the user by inserting them into the filter choices container
function updateChoices() {
    // clear choices
    document.querySelector(".collectionChoicesBody").innerHTML = "";

    // if no choices, hide container and return
    if (filterChoices.length === 0 && filterChoicesPrices.length === 0) {
        document.querySelector(".collectionChoices").classList.remove("active");
        return;
    }

    // activate container
    document.querySelector(".collectionChoices").classList.add("active");

    // add cleaned choices to body - only show the values
    // cleanChoices.forEach(function (item) {
    // document.querySelector(".collectionChoicesBody").insertAdjacentHTML("beforeend", `
    //             <button class="collectionChoicesBodyItem">
    //                 ${item}
    //                 <svg class="collectionChoicesBodyItemImg" xmlns="http://www.w3.org/2000/svg" width="5" height="5"
    //                      viewBox="0 0 5 5" fill="none">
    //                     <path fill-rule="evenodd" clip-rule="evenodd"
    //                           d="M5 4.50719L0.492814 0L0 0.492814L4.50719 5L5 4.50719Z" fill="black"/>
    //                     <path fill-rule="evenodd" clip-rule="evenodd"
    //                           d="M0.492814 5L5 0.492814L4.50719 0L0 4.50719L0.492814 5Z" fill="black"/>
    //                 </svg>
    //             </button>
    //         `);
    // });

    // add filter choices to body
    filterChoices.forEach(function (item) {
        let cleanedItem = item.split(':')[1];
        document.querySelector(".collectionChoicesBody").insertAdjacentHTML("beforeend", `
            <button class="collectionChoicesBodyItem">
                ${cleanedItem}
                <svg class="collectionChoicesBodyItemImg" xmlns="http://www.w3.org/2000/svg" width="5" height="5"
                     viewBox="0 0 5 5" fill="none">
                    <path fill-rule="evenodd" clip-rule="evenodd"
                          d="M5 4.50719L0.492814 0L0 0.492814L4.50719 5L5 4.50719Z" fill="black"/>
                    <path fill-rule="evenodd" clip-rule="evenodd"
                          d="M0.492814 5L5 0.492814L4.50719 0L0 4.50719L0.492814 5Z" fill="black"/>
                </svg>
            </button>
        `);
    });

    // add price choices to body
    filterChoicesPrices.forEach(function (item) {
        document.querySelector(".collectionChoicesBody").insertAdjacentHTML("beforeend", `
                    <button class="collectionChoicesBodyItem">
                        ${item}
                        <svg class="collectionChoicesBodyItemImg" xmlns="http://www.w3.org/2000/svg" width="5" height="5"
                             viewBox="0 0 5 5" fill="none">
                            <path fill-rule="evenodd" clip-rule="evenodd"
                                  d="M5 4.50719L0.492814 0L0 0.492814L4.50719 5L5 4.50719Z" fill="black"/>
                            <path fill-rule="evenodd" clip-rule="evenodd"
                                  d="M0.492814 5L5 0.492814L4.50719 0L0 4.50719L0.492814 5Z" fill="black"/>
                        </svg>
                    </button>
                `);
    });
    updateSearchFilter();
}

// call each page load to load in currently selected tags
updateChoices();

// update checkboxes
function updateCheckboxes() {
    // for each checkbox in that filter
    document.querySelectorAll(".filterItemInput").forEach(function (checkbox) {
        // if the checkbox value is in the filter choices, check it
        if (filterChoices.includes(checkbox.value)) {
            checkbox.checked = true;
        }
    });
}

// run on page load to show checked checkboxes
updateCheckboxes();


// update search filter
// creates link for selected tags and takes user to that page
function updateSearchFilter() {
    // // update the search anchor tag
    document.querySelectorAll('.collectionSearch').forEach(function (element) {
        element.href = createUrlParams();
    });
}

// clear filter listener
document.querySelectorAll(".clearFilter").forEach(function (element) {
    element.addEventListener("click", function () {
        clearFilter();
    });
});

// clear filter function and return to base url
function clearFilter() {
    // clear filter choices
    filterChoices = [];
    updateChoices();

    // uncheck all choice option
    document.querySelectorAll(".filterItemInput").forEach(function (element) {
        element.checked = false;
    });

    // link them to base url
    window.location = `/collections/${collection.handle}/`;
}

// clear single choice listener
document.addEventListener("click", function (event) {
    if (event.target.classList.contains("collectionChoicesBodyItem")) {
        clearChoice(event.target);
    }
});

// clear a single choice
function clearChoice(element) {
    // uncheck choice option from filter menu
    document.querySelectorAll(".filterItemInput").forEach(function (choice) {
        // if the choice is the same as the element text, unchecked it
        if (choice.value.includes(element.textContent.trim())) {
            choice.checked = false;
        }
    });

    // remove item from choices array
    // the choice array items have the format of _group:value - we only want to filter by the value
    filterChoices = filterChoices.filter(item => {
        let value = item.split(':')[1];
        return value !== element.textContent.trim();
    });

    filterChoicesPrices = [];

    updateChoices();

    // create url filter params and change url to that location
    window.location = createUrlParams();
}


/**********************
 MOBILE functions
 **********************/

// open filter dialog lister
document.querySelector(".collectionControlsMobile").addEventListener("click", function () {
    document.querySelector("#filter").showModal();
    document.querySelector("#filterBody").classList.add("active");
    document.querySelector("body").classList.add("noScroll");
    // show checked checkboxes if there are any
    updateCheckboxes();
});

// close filter dialog
document.querySelectorAll("#filter .closeFilterDialog").forEach(function (element) {
    element.addEventListener("click", function () {
        document.querySelector("#filterBody").classList.remove("active");
        document.querySelector("body").classList.remove("noScroll");
        document.querySelector("#filter").close();
    });
});


// search mobile filter results
document.querySelector("#filterBodyFooterClose").addEventListener("click", function () {
    // create url filter params and change url to that location
    window.location = createUrlParams();
});


//faq like event listeners for each of the dropdowns
document.querySelectorAll(`#filter .filterBodyContentItemTitle`).forEach(function (element) {
    element.addEventListener("click", function () {
        this.parentElement.classList.toggle("active");
    });
});


// check if the filter size is just 1 and if so, hide the filter
// ie color only has red
document.querySelectorAll('.collectionControlsFilters')?.forEach(function (element) {
    let filterSize = element.querySelectorAll('.filterItem').length;
    if (filterSize === 1) {
        element.classList.add('active');
    }
});